import {
  request,
  success,
  failure,
  TASK_REQUEST,
  PROJECT_BACKLOG,
} from "../actions/utilities";
import {
  getTaskList,
  removeTask,
  editTask,
  fetchProjectBoards,
  fetchTaskboardStatuses,
  createNewTaskboard,
  createProjectTask,
  removeBoard,
  changeTaskStatus,
  inviteEmployee,
  removeEmployee,
  createQaTemplate,
  fetchQaTemplates,
  removeQaTemplate,
  getUsersDataForInviteInProject,
  fetchNextBoardTask,
  filterTaskByMilesoneApi,
  fetchWorkingHours,
  updateBulkTaskData,
  updateTaskBoardsOrderApi,
} from "../api";

import { APP_SETTINGS } from "../../config";
import { GetRequest, PostRequest } from "../api/genericApiCalls";
import { taskReducer } from "../reducers/taskReducer";

export function getAllTask() {
  return (dispatch) => {
    dispatch(request(TASK_REQUEST.GET_TASK_REQUEST));
    getTaskList().then(
      (response) => {
        if (response.data.status === 1) {
          dispatch(success(TASK_REQUEST.GET_TASK_SUCCESS, response.data.data));
        } else {
          dispatch(
            failure(TASK_REQUEST.GET_TASK_FAILURE, response.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            TASK_REQUEST.GET_TASK_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function addTask(taskData, token, addTaskResponse) {
  return (dispatch) => {
    dispatch(request(TASK_REQUEST.CREATE_TASK_REQUEST));
    createProjectTask(taskData, token).then(
      (response) => {
        if (response.data.status === 1) {
          dispatch(
            success(TASK_REQUEST.CREATE_TASK_SUCCESS, response.data.data)
          );
          if (addTaskResponse) {
            addTaskResponse(response);
          }
        } else {
          dispatch(
            failure(TASK_REQUEST.CREATE_TASK_FAILURE, response.data.message)
          );
          if (addTaskResponse) {
            addTaskResponse(response);
          }
        }
        // console.log("task: ", response);
      },
      (error) => {
        // if (responseErrorFunc) {
        //   responseErrorFunc(true);
        // }
        dispatch(
          failure(
            TASK_REQUEST.CREATE_TASK_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function updateBulkTask(taskData, token, callback) {
  return (dispatch) => {
    dispatch({ type: TASK_REQUEST.UPDATE_BULK_TASK_REQUEST });

    updateBulkTaskData(taskData, token).then(
      (response) => {
        // console.log("response c", response);
        if (response.data.status === 1) {
          dispatch({
            type: TASK_REQUEST.UPDATE_BULK_TASK_SUCCESS,
            payload: response.data,
          });

          if (callback) {
            callback(true, response.data);
          }
        } else {
          dispatch({
            type: TASK_REQUEST.UPDATE_BULK_TASK_FAILURE,
            payload: response.data.message,
          });

          if (callback) {
            callback(false, response.data.message);
          }
        }
      },
      (error) => {
        dispatch({
          type: TASK_REQUEST.UPDATE_BULK_TASK_FAILURE,
          payload:
            error?.response?.data?.title ||
            error.message ||
            "Something went wrong",
        });

        if (callback) {
          callback(false, error);
        }
      }
    );
  };
}

export function deleteTask(taskId, token) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(request(TASK_REQUEST.DELETE_TASK_REQUEST));

      removeTask(taskId, token)
        .then((response) => {
          if (response.data.status === 1) {
            dispatch(success(TASK_REQUEST.DELETE_TASK_SUCCESS, taskId));
            resolve(); // ✅ Make sure resolve is called
          } else {
            dispatch(
              failure(TASK_REQUEST.DELETE_TASK_FAILURE, response.data.message)
            );
            reject(response.data.message);
          }
        })
        .catch((error) => {
          const errorMessage = error?.response?.data?.title || error.message;
          dispatch(failure(TASK_REQUEST.DELETE_TASK_FAILURE, errorMessage));
          reject(errorMessage);
        });
    });
  };
}

export function deleteBoard(boardId, token) {
  return (dispatch) => {
    dispatch(request(TASK_REQUEST.DELETE_TASK_BOARD_REQUEST));
    removeBoard(boardId, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(success(TASK_REQUEST.DELETE_TASK_BOARD_SUCCESS, boardId));
        } else {
          dispatch(
            failure(TASK_REQUEST.DELETE_TASK_BOARD_FAILURE, res.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            TASK_REQUEST.DELETE_TASK_BOARD_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function updateTask(task, token, info, Notification) {
  return (dispatch) => {
    dispatch(request(TASK_REQUEST.EDIT_TASK_REQUEST));

    return editTask(task, token).then(
      (response) => {
        if (Notification) {
          Notification(response.data.message, "success");
        }

        if (response.data.status === 1) {
          dispatch(
            success(TASK_REQUEST.EDIT_TASK_SUCCESS, response.data.data, info)
          );
          dispatch(request(TASK_REQUEST.TASK_RESET_PARTIAL_STATE));
        } else {
          dispatch(
            failure(TASK_REQUEST.EDIT_TASK_FAILURE, response.data.message)
          );
          if (Notification) {
            Notification(response.data.message, "error");
          }
        }

        return response;
      },
      (error) => {
        const errMsg =
          error?.response?.data?.title || error.message || "An error occurred";

        dispatch(failure(TASK_REQUEST.EDIT_TASK_FAILURE, errMsg));

        if (Notification) {
          Notification(errMsg, "error");
        }

        throw error;
      }
    );
  };
}

export function updateTaskStatus(data, token) {
  return (dispatch) => {
    dispatch(request(TASK_REQUEST.CHANGE_TASK_STATUS_REQUEST));
    changeTaskStatus(data, token).then(
      (res) => {
        if (res.data) {
          // dispatch(success(TASK_REQUEST.CHANGE_TASK_STATUS_SUCCESS, data));
        } else {
          dispatch(
            failure(TASK_REQUEST.CHANGE_TASK_STATUS_FAILURE, res.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            TASK_REQUEST.CHANGE_TASK_STATUS_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
export function getFilterTaskMilestones(projectId, token, MoveToNext) {
  return (dispatch) => {
    dispatch(request(PROJECT_BACKLOG.FILTER_TASK_BY_MILESTONE_REQUEST));
    filterTaskByMilesoneApi(projectId, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(TASK_REQUEST.GET_PROJECT_BOARDS_SUCCESS, res.data.data)
          );
          if (MoveToNext) {
            MoveToNext({ columns: res.data.data });
          }
        } else {
          dispatch(
            failure(TASK_REQUEST.GET_PROJECT_BOARDS_FAILURE, res.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECT_BACKLOG.FILTER_TASK_BY_MILESTONE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

// let cachedBoards = null;
// let cacheTimestamp = null;
// const CACHE_TTL = 300000; // 5 minutes

// function isCacheValid() {
//   return cacheTimestamp && Date.now() - cacheTimestamp < CACHE_TTL;
// }

// export function getProjectBoards(
//   data,
//   token,
//   MoveToNext,
//   forceRefresh = false
// ) {
//   return (dispatch) => {
//     // Bypass cache if forceRefresh is true
//     if (!forceRefresh && cachedBoards && isCacheValid()) {
//       console.log("Fetching from cache...");
//       dispatch(success(TASK_REQUEST.GET_PROJECT_BOARDS_SUCCESS, cachedBoards));
//       if (MoveToNext) MoveToNext({ columns: cachedBoards });
//       return;
//     }

//     console.log("Fetching from server...");
//     dispatch(request(TASK_REQUEST.GET_PROJECT_BOARDS_REQUEST));

//     fetchProjectBoards(data, token).then(
//       (res) => {
//         if (res.data.status === 1) {
//           cachedBoards = res.data.data;
//           cacheTimestamp = Date.now();
//           dispatch(
//             success(TASK_REQUEST.GET_PROJECT_BOARDS_SUCCESS, res.data.data)
//           );
//           if (MoveToNext) MoveToNext({ columns: res.data.data });
//         } else {
//           dispatch(
//             failure(TASK_REQUEST.GET_PROJECT_BOARDS_FAILURE, res.data.message)
//           );
//         }
//       },
//       (error) => {
//         dispatch(
//           failure(
//             TASK_REQUEST.GET_PROJECT_BOARDS_FAILURE,
//             error.response?.data?.title || error.message
//           )
//         );
//       }
//     );
//   };
// }

// // Function to manually invalidate cache
// export function invalidateCache() {
//   cachedBoards = null;
//   cacheTimestamp = null;
//   console.log("Cache invalidated.");
// }

// Debugging Utility
// window.debugCache = () => ({
//   cachedBoards,
//   cacheTimestamp,
//   isCacheValid: isCacheValid(),
// });
export function getWorkingHours(data, token, callback) {
  return (dispatch) => {
    dispatch(request(TASK_REQUEST.GET_WORKING_HOURS_REQUEST));

    fetchWorkingHours(data, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(TASK_REQUEST.GET_WORKING_HOURS_SUCCESS, res.data.data)
          );
          if (callback) callback(res.data.data); // ✅ Pass data to next function
        } else {
          dispatch(
            failure(TASK_REQUEST.GET_WORKING_HOURS_FAILURE, res.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            TASK_REQUEST.GET_WORKING_HOURS_FAILURE,
            error.response?.data?.title || error.message
          )
        );
      }
    );
  };
}

export function getProjectBoards(data, token, MoveToNext) {
  return (dispatch) => {
    dispatch(request(TASK_REQUEST.GET_PROJECT_BOARDS_REQUEST));

    fetchProjectBoards(data, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(TASK_REQUEST.GET_PROJECT_BOARDS_SUCCESS, res.data.data)
          );
          if (MoveToNext) MoveToNext({ columns: res.data.data });
        } else {
          dispatch(
            failure(TASK_REQUEST.GET_PROJECT_BOARDS_FAILURE, res.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            TASK_REQUEST.GET_PROJECT_BOARDS_FAILURE,
            error.response?.data?.title || error.message
          )
        );
      }
    );
  };
}
export function updateBoardOrder(
  userId,
  data,
  token,
  projectId,
  onSuccessCallback
) {
  return (dispatch) => {
    dispatch(request(TASK_REQUEST.UPDATE_TASK_BOARDS_ORDER_REQUEST));

    updateTaskBoardsOrderApi(userId, data, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              TASK_REQUEST.UPDATE_TASK_BOARDS_ORDER_SUCCESS,
              res.data.data
            )
          );

          if (onSuccessCallback) {
            onSuccessCallback();
          }
        } else {
          dispatch(
            failure(
              TASK_REQUEST.UPDATE_TASK_BOARDS_ORDER_FAILURE,
              res.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            TASK_REQUEST.UPDATE_TASK_BOARDS_ORDER_FAILURE,
            error.response?.data?.title || error.message
          )
        );
      }
    );
  };
}

export function clearTask() {
  return (dispatch) => {
    dispatch({
      type: TASK_REQUEST.CLEAR_TASK,
    });
  };
}

export function getNextBoardTask(data, token) {
  return (dispatch) => {
    dispatch(request(TASK_REQUEST.GET_NEXT_PROJECT_TASK_BOARDS_REQUEST));
    fetchNextBoardTask(data, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              TASK_REQUEST.GET_NEXT_PROJECT_TASK_BOARDS_SUCCESS,
              res.data.data
            )
          );
        } else {
          dispatch(
            failure(
              TASK_REQUEST.GET_NEXT_PROJECT_TASK_BOARDS_FAILURE,
              res.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            TASK_REQUEST.GET_NEXT_PROJECT_TASK_BOARDS_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function getTaskboardStatus(token) {
  return (dispatch) => {
    dispatch(request(TASK_REQUEST.GET_TASK_BOARD_STATUS_REQUEST));
    fetchTaskboardStatuses(token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(TASK_REQUEST.GET_TASK_BOARD_STATUS_SUCCESS, res.data.data)
          );
        } else {
          dispatch(
            failure(
              TASK_REQUEST.GET_TASK_BOARD_STATUS_FAILURE,
              res.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            TASK_REQUEST.GET_TASK_BOARD_STATUS_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function createTaskBoard(data, token, moveToNext) {
  return (dispatch) => {
    dispatch(request(TASK_REQUEST.CREATE_TASK_BOARD_REQUEST));
    createNewTaskboard(data, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(TASK_REQUEST.CREATE_TASK_BOARD_SUCCESS, res.data.data)
          );
          if (moveToNext) {
            moveToNext(res);
          }
        } else {
          dispatch(
            failure(TASK_REQUEST.CREATE_TASK_BOARD_FAILURE, res.data.message)
          );
          if (moveToNext) {
            moveToNext(res);
          }
        }
      },
      (error) => {
        dispatch(
          failure(
            TASK_REQUEST.CREATE_TASK_BOARD_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function editTaskboard(data, token, moveToNext) {
  return (dispatch) => {
    dispatch(request(TASK_REQUEST.EDIT_TASK_BOARD_REQUEST));
    createNewTaskboard(data, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(TASK_REQUEST.EDIT_TASK_BOARD_SUCCESS, res.data.data)
          );
          if (moveToNext) {
            moveToNext(res);
          }
        } else {
          dispatch(
            failure(TASK_REQUEST.EDIT_TASK_BOARD_FAILURE, res.data.message)
          );
          if (moveToNext) {
            moveToNext(res);
          }
        }
      },
      (error) => {
        dispatch(
          failure(
            TASK_REQUEST.EDIT_TASK_BOARD_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function setProject(projectName) {
  return (dispatch) => {
    dispatch(success(TASK_REQUEST.PROJECT_SELECTED, projectName));
  };
}

export function sendInvite(data, token, moveToNext, Notification) {
  return (dispatch) => {
    dispatch(request(TASK_REQUEST.SEND_INVITE_REQUEST));

    return inviteEmployee(data, token)
      .then((res) => {
        if (res) {
          dispatch(success(TASK_REQUEST.SEND_INVITE_SUCCESS, res));

          if (moveToNext) {
            moveToNext();
          }
          if (Notification) {
            Notification(res.data.message, "success");
          }
        } else {
          dispatch(failure(TASK_REQUEST.SEND_INVITE_FAILURE, res));
          if (Notification) {
            Notification(res.data.message, "error");
          }
        }
        return res;
      })
      .catch((error) => {
        dispatch(
          failure(
            TASK_REQUEST.SEND_INVITE_FAILURE,
            error?.response?.data?.title || error.message
          )
        );
        throw error;
      });
  };
}

export function getUsersDataForInviteInProject_Action(id, token) {
  return (dispatch) => {
    dispatch(request(TASK_REQUEST.USER_LIST_INVITE_REQUEST));
    getUsersDataForInviteInProject(id, token).then(
      (res) => {
        if (res) {
          if (res.data.status === 1) {
            dispatch(
              success(TASK_REQUEST.USER_LIST_INVITE_SUCCESS, res.data.data)
            );
          } else {
            dispatch(
              failure(TASK_REQUEST.USER_LIST_INVITE_FAILURE, res.data.message)
            );
          }
        }
      },
      (error) => {
        dispatch(
          failure(
            TASK_REQUEST.USER_LIST_INVITE_FAILURE,
            error && error.response && error.response.data
          )
        );
      }
    );
  };
}

export function removeEmployeeFromProject(data, token) {
  return (dispatch) => {
    dispatch(request(TASK_REQUEST.REMOVE_USER_FROM_PROJECT_REQUEST));
    removeEmployee(data, token).then(
      (res) => {
        // console.log("response from removeEmp::", res);
        if (res) {
          dispatch(
            success(TASK_REQUEST.REMOVE_USER_FROM_PROJECT_SUCCESS, data)
          );
        } else {
          dispatch(
            failure(
              TASK_REQUEST.REMOVE_USER_FROM_PROJECT_FAILURE,
              "Something went wrong!"
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            TASK_REQUEST.REMOVE_USER_FROM_PROJECT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function getQaTemplates(data, token) {
  return (dispatch) => {
    dispatch(request(TASK_REQUEST.GET_QA_TEMPLATE_REQUEST));
    fetchQaTemplates(data, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(TASK_REQUEST.GET_QA_TEMPLATE_SUCCESS, res.data.data)
          );
        } else {
          dispatch(
            failure(TASK_REQUEST.GET_QA_TEMPLATE_FAILURE, res.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            TASK_REQUEST.GET_QA_TEMPLATE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function addQaTemplate(data, token, moveToNext, Notification) {
  return (dispatch) => {
    dispatch(request(TASK_REQUEST.ADD_QA_TEMPLATE_REQUEST));
    createQaTemplate(data, token).then(
      (res) => {
        if (res.data.status === 200) {
          dispatch(
            success(TASK_REQUEST.ADD_QA_TEMPLATE_SUCCESS, res.data.data)
          );
          if (moveToNext) moveToNext();
          if (Notification) Notification(res.data.message, "success");
        } else {
          dispatch(
            failure(TASK_REQUEST.ADD_QA_TEMPLATE_FAILURE, res.data.message)
          );
          if (Notification) Notification(res.data.message, "error");
        }
      },
      (error) => {
        dispatch(
          failure(
            TASK_REQUEST.ADD_QA_TEMPLATE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

// export function updateQaTemplate(data, token) {
//     return (dispatch) => {
//         dispatch(request(TASK_REQUEST.UPDATE_QA_TEMPLATE_REQUEST));
//         createQaTemplate(data, token).then((res) => {
//             if (res.data.status === 1) {
//                 dispatch(success(TASK_REQUEST.UPDATE_QA_TEMPLATE_SUCCESS, res.data.data));
//             }
//             else {
//                 dispatch(failure(TASK_REQUEST.UPDATE_QA_TEMPLATE_FAILURE, res.data.message));
//             }
//         }, (error) => {
//             dispatch(failure(TASK_REQUEST.UPDATE_QA_TEMPLATE_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
//         })
//     }
// }

export function deleteQaTemplate(data, token) {
  return (dispatch) => {
    dispatch(request(TASK_REQUEST.REMOVE_QA_TEMPLATE_REQUEST));
    removeQaTemplate(data, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(success(TASK_REQUEST.REMOVE_QA_TEMPLATE_SUCCESS, data));
        } else {
          dispatch(
            failure(TASK_REQUEST.REMOVE_QA_TEMPLATE_FAILURE, res.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            TASK_REQUEST.REMOVE_QA_TEMPLATE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function FetchCommentOfTaskInKanban(taskId, infoObject, token) {
  return (dispatch) => {
    dispatch(request(TASK_REQUEST.GET_COMMENT_IN_KANBAN_REQUEST));
    var path = `${APP_SETTINGS.API_PATH.TASK.getCommentOfTaskInKanban}?taskId=${taskId}`;
    PostRequest(path, null, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              TASK_REQUEST.GET_COMMENT_IN_KANBAN_SUCCESS,
              res.data.data,
              infoObject
            )
          );
        } else {
          dispatch(
            failure(
              TASK_REQUEST.GET_COMMENT_IN_KANBAN_FAILURE,
              res.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            TASK_REQUEST.GET_COMMENT_IN_KANBAN_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function SaveCommentTaskInKanban(reqObject, token, indexInfo) {
  return (dispatch) => {
    dispatch(request(TASK_REQUEST.ADD_COMMENT_IN_KANBAN_REQUEST));
    PostRequest(
      APP_SETTINGS.API_PATH.TASK.postCommentOfTaskInKanban,
      reqObject,
      token
    ).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              TASK_REQUEST.ADD_COMMENT_IN_KANBAN_SUCCESS,
              res.data.data,
              indexInfo
            )
          );
          // Keep comment list consistent with backend truth
          if (reqObject?.taskId) {
            dispatch(
              FetchCommentOfTaskInKanban(
                reqObject.taskId,
                { taskId: reqObject.taskId },
                token
              )
            );
          }
        } else {
          dispatch(
            failure(
              TASK_REQUEST.ADD_COMMENT_IN_KANBAN_FAILURE,
              res.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            TASK_REQUEST.ADD_COMMENT_IN_KANBAN_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function DeleteCommentTaskInKanban(commentId, info, token) {
  return (dispatch) => {
    dispatch(request(TASK_REQUEST.DELETE_COMMENT_IN_KANBAN_REQUEST));
    var path = `${APP_SETTINGS.API_PATH.TASK.deleteCommentOfTaskInKanban}?commentId=${commentId}`;
    PostRequest(path, null, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              TASK_REQUEST.DELETE_COMMENT_IN_KANBAN_SUCCESS,
              res.data.data,
              info
            )
          );
          // Re-sync comments after deletion to avoid index mismatch issues
          if (info?.taskId) {
            dispatch(
              FetchCommentOfTaskInKanban(
                info.taskId,
                { taskId: info.taskId },
                token
              )
            );
          }
        } else {
          dispatch(
            failure(
              TASK_REQUEST.DELETE_COMMENT_IN_KANBAN_FAILURE,
              res.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            TASK_REQUEST.DELETE_COMMENT_IN_KANBAN_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function GetTaskHistory(taskId, info, token) {
  return (dispatch) => {
    dispatch(request(TASK_REQUEST.GET_TASK_WORKHISTORY_REQUEST));
    var path = `${APP_SETTINGS.API_PATH.TASK.getTaskHistory}?taskId=${taskId}`;
    PostRequest(path, null, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              TASK_REQUEST.GET_TASK_WORKHISTORY_SUCCESS,
              res.data.data,
              info
            )
          );
        } else {
          dispatch(
            failure(TASK_REQUEST.GET_TASK_WORKHISTORY_FAILURE, res.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            TASK_REQUEST.GET_TASK_WORKHISTORY_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function TaskWorkLogAction(req, info, token) {
  return (dispatch) => {
    dispatch(request(TASK_REQUEST.ADD_TASK_WORKLOG_REQUEST));
    PostRequest(APP_SETTINGS.API_PATH.TASK.postTaskWorkLog, req, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(TASK_REQUEST.ADD_TASK_WORKLOG_SUCCESS, res.data.data, info)
          );
        } else {
          dispatch(
            failure(TASK_REQUEST.ADD_TASK_WORKLOG_FAILURE, res.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            TASK_REQUEST.ADD_TASK_WORKLOG_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function GetTaskWorkLog(taskId, info, token) {
  return (dispatch) => {
    dispatch(request(TASK_REQUEST.GET_TASK_WORKLOG_REQUEST));
    var path = `${APP_SETTINGS.API_PATH.TASK.getTaskWorkLog}?taskId=${taskId}`;
    PostRequest(path, null, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(TASK_REQUEST.GET_TASK_WORKLOG_SUCCESS, res.data.data, info)
          );
        } else {
          dispatch(
            failure(TASK_REQUEST.GET_TASK_WORKLOG_FAILURE, res.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            TASK_REQUEST.GET_TASK_WORKLOG_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function deleteTaskAttachment(attachmentId, token, info) {
  return (dispatch) => {
    dispatch(request(TASK_REQUEST.DELETE_TASK_ATTACHMENT_REQUEST));
    var path = `${APP_SETTINGS.API_PATH.TASK.deleteAttachment}?attachmentId=${attachmentId}`;
    PostRequest(path, null, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              TASK_REQUEST.DELETE_TASK_ATTACHMENT_SUCCESS,
              res.data.data,
              info
            )
          );
        } else {
          dispatch(
            failure(
              TASK_REQUEST.DELETE_TASK_ATTACHMENT_FAILURE,
              res.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            TASK_REQUEST.DELETE_TASK_ATTACHMENT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
